import getErrorTags from './getErrorTags';

/**
 * Gets the closest FormWizard `form` tag associated with an element
 *
 * @param {Element} element
 */
export default function getErrorTag(element) {
  if (!element) return;
  return getErrorTags(element)[0];
}
